module.exports = __webpack_public_path__ + "static/media/gsb-iconAll.51bd15a6.svg";